<template lang="pug">
  .center.panel-users()
    .user-add( v-if=" typeForm != 2" )
      h6 Agregar nuevo usuario.
      form( name="UsuarioAlta")
        .col.s12: .row
          .input-field.col.s12
            input(id="mail" type="email" class="validate" required v-model="da.mail")
            label(for="mail") Correo

          .input-field.col.s12
            input(id="name" type="text" class="validate" required v-model="da.nombre")
            label(for="name") Nombre
          .input-field.col.s12
            select.browser-default(required v-model="da.rol" )
              option(value="none" disabled selected) Asignar Rol 
              option( v-for="it in rolesValues" :value="it.id" ) {{it.name}}
          
          .input-field.col.s12()
            | Cliente
            input( id="cliente_name"  class="validate"  type="text" v-model="da.cliente" required )
          .input-field.col.s6
            button(class="btn waves-effect waves-light red darken-4 white-text" :disabled=" da.mail.length < 5 " type="submit" name="cancelar" @click.prevent="cancelCreated()")
              | Cancelar
              i.material-icons.right close
          .input-field.col.s6
            button.btn.waves-effect.waves-light.light-blue.darken-4.white-text( type="submit" name="action" @click.prevent="GuaradarCambio(da)")
              | Guardar
              i.material-icons.right send

    .user-edit( v-else )
      h6 Editar usuario.
      form( name="UsuarioUpdate")
        .col.s12: .row
          .input-field.col.s11
            | Nombre
            input(id="name"  type="text" v-model="datosUser.name" required)
          .input-input-field.col.s1
            a.btn-floating.btn-small.waves-effect.waves-light.red(@click="cancelSave")
              i.material-icons close
          .input-field.col.s12
            select.browser-default(required v-model="datosUser.rol" id="RolID" )
              option( v-for="it in rolesValues" :value="it.id" ) {{it.name}}
          .input-field.col.s12()
            | Cliente
            input( id="cliente_name"  type="text" v-model="datosUser.cliente" required )
          .input-field.col.s6
            button(class="btn waves-effect waves-light red darken-4 white-text" type="submit" name="cancelar" @click.prevent="DeleteElement(datosUser)")
              | Eliminar
              i.material-icons.right close
          .input-field.col.s6
            button.btn.waves-effect.waves-light.light-blue.darken-4(type="submit" name="guardar" @click.prevent="GuaradarCambio(datosUser)")
              | Guardar
              i.material-icons.right send
</template>
<style>
  .panel-users{
    max-width: 500px;
  }
  select.browser-default{
    text-transform: capitalize;
  }
</style>
<script>
export default {
  props:{ // default: () => { return {}}
    title:       { type: String , default: () => { return ' - - -'} },
    typeForm:    { type: Number , default: () => { return 0} },
    datosUser:   { type: Object , default: () => { return {} } },
    rolesValues: { type: Array },
    defaultData: { type: Object , default: () => { return { nombre:"", rol:"none", mail:""} } },
  },
  data() {
    return {
      da:{ nombre:"", rol:"none", mail:"", cliente:""}
     
    }
  },
  methods: {
    asigClient(){
      if( !this.datosUser.cliente )
        this.datosUser.cliente == "Levantek"; 
      else
        console.log('Lalallalalal ', this.datosUser.cliente);
    },
    cancelCreated(){
      this.da = { nombre:"", rol:"none", mail:"", cliente:"" }; 
    },
    DeleteElement(_i){
      this.$emit('saveOrUpdate', 100 ,_i);
    },
    validacionDa(){
      if(this.da.nombre == "" || this.da.mail == "" || this.da.cliente == "" )
      {
        alert(" Todos los campos son obligatorios.");
        return false;
      }else if(this.da.rol == "none"){
        alert(" Favor de asignar un rol.");
        return false;
      }else{
        return true;
      }
        
    },
    GuaradarCambio(_i){
      if(this.typeForm == 2){
        this.$emit('saveOrUpdate', this.typeForm ,_i);
      }
      else{
        if( this.validacionDa() ){
          this.$emit('saveOrUpdate', this.typeForm ,_i);
          this.da = { nombre:"", rol:"none", mail:""}; 
        }
      }
    },
    cancelSave (){
      this.typeForm = 1;
      this.datosUser = {};
    },
  },
  created() {
    
    // this.asigClient();
    // console.log( "DATOS USER VALUE IS: ", this.datosUser);
  }
}
</script>